export default "__VITE_ASSET__C25kLcsg__"